<template>
  <div class="progress-container">
    <!-- Texte -->
    <div class="progress-header">
      <span class="step-label">Étape {{ currentStep }} / {{ totalSteps }}</span>
    </div>

    <!-- Steps -->
    <div class="steps">
      <div
          v-for="step in totalSteps"
          :key="step"
          class="step"
          :class="{
          active: step === currentStep,
          completed: step < currentStep
        }"
      >
        <div class="circle"></div>
      </div>

      <!-- Barre -->
      <div class="progress-bar">
        <div class="progress-fill" :style="progressStyle"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue"

const props = defineProps({
  currentStep: {
    type: Number,
    required: true
  },
  totalSteps: {
    type: Number,
    required: true
  }
})

const progress = computed(() => {
  return ((props.currentStep - 1) / (props.totalSteps - 1)) * 100
})

const progressStyle = computed(() => ({
  width: `${progress.value}%`
}))
</script>

<style scoped>
.progress-container {
  width: calc(100% - 32px);
  max-width: 500px;
  padding: 12px 16px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  font-family: system-ui, sans-serif;
}

/* Header */
.progress-header {
  margin-bottom: 10px;
  font-size: 14px;
  color: #555;
}

.step-label {
  font-weight: 500;
}

/* Steps */
.steps {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Step */
.step {
  position: relative;
  z-index: 2;
}

.circle {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #ddd;
  transition: all 0.3s ease;
}

/* States */
.step.completed .circle {
  background: #d7b511;
}

.step.active .circle {
  background: #d7b511;
  transform: scale(1.2);
  box-shadow: 0 0 0 4px rgba(243, 226, 33, 0.3);
}

/* Progress bar */
.progress-bar {
  position: absolute;
  height: 4px;
  background: #eee;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, rgba(215, 181, 17, 0.2), #d7b511);
  transition: width 0.4s ease;
}
</style>